import React from 'react';
import {colors} from '../theme/tokens/colors';
import {EthereumNetworkIcon} from './ethereum-network';
import {PolygonIcon} from './polygon';
import {ZilliqaIcon} from './zilliqa';
import {BitcoinIcon} from './bitcoin';

type NetworkName = 'ethereum' | 'polygon' | 'zilliqa';

const NetworkIconComponentMap: Record<
  NetworkName,
  // Icon-like component
  (props: {
    size: number | undefined;
    color: keyof typeof colors | (string & Record<string, never>) | undefined;
  }) => JSX.Element | null
> = {
  ethereum: EthereumNetworkIcon,
  polygon: PolygonIcon,
  zilliqa: ZilliqaIcon,
};

export interface NetworkIconProps {
  name: NetworkName;
  size?: number;
  color?: keyof typeof colors | (string & Record<string, never>);
}

export const NetworkIcon: React.FC<NetworkIconProps> = ({
  size,
  color,
  name,
}) => {
  const NetworkIconComponent = NetworkIconComponentMap[name];
  return NetworkIconComponent ? (
    <NetworkIconComponent size={size} color={color} />
  ) : null;
};
